const Country = [
	{
		type: 'Afghanistan',
		'ISO2': 'AF',
		'E164': 93,
		'prefix': '93',
		'fr': 'Afghanistan'
	},
	{
		type: 'Albania',
		'ISO2': 'AL',
		'E164': 355,
		'prefix': '355',
		'fr': 'Albanie'
	},
	{
		type: 'Algeria',
		'ISO2': 'DZ',
		'E164': 213,
		'prefix': '213',
		'fr': 'Algérie'
	},
	{
		type: 'American Samoa',
		'ISO2': 'AS',
		'E164': 1,
		'prefix': '1-684',
		'fr': 'Samoa américaines'
	},
	{
		type: 'Andorra',
		'ISO2': 'AD',
		'E164': 376,
		'prefix': '376',
		'fr': 'Andorre'
	},
	{
		type: 'Angola',
		'ISO2': 'AO',
		'E164': 244,
		'prefix': '244',
		'fr': 'Angola'
	},
	{
		type: 'Anguilla',
		'ISO2': 'AI',
		'E164': 1,
		'prefix': '1-264',
		'fr': 'Anguilla'
	},
	{
		type: 'Antarctica',
		'ISO2': 'AQ',
		'E164': 672,
		'prefix': '672',
		'fr': 'Antarctique'
	},
	{
		type: 'Antigua and Barbuda',
		'ISO2': 'AG',
		'E164': 1,
		'prefix': '1-268',
		'fr': 'Antigua-et-Barbuda'
	},
	{
		type: 'Argentina',
		'ISO2': 'AR',
		'E164': 54,
		'prefix': '54',
		'fr': 'Argentine'
	},
	{
		type: 'Armenia',
		'ISO2': 'AM',
		'E164': 374,
		'prefix': '374',
		'fr': 'Arménie'
	},
	{
		type: 'Aruba',
		'ISO2': 'AW',
		'E164': 297,
		'prefix': '297',
		'fr': 'Aruba'
	},
	{
		type: 'Australia',
		'ISO2': 'AU',
		'E164': 61,
		'prefix': '61',
		'fr': 'Australie'
	},
	{
		type: 'Austria',
		'ISO2': 'AT',
		'E164': 43,
		'prefix': '43',
		'fr': 'Autriche'
	},
	{
		type: 'Azerbaijan',
		'ISO2': 'AZ',
		'E164': 994,
		'prefix': '994',
		'fr': 'Azerbaïdjan'
	},
	{
		type: 'Bahamas',
		'ISO2': 'BS',
		'E164': 1,
		'prefix': '1-242',
		'fr': 'Bahamas'
	},
	{
		type: 'Bahrain',
		'ISO2': 'BH',
		'E164': 973,
		'prefix': '973',
		'fr': 'Bahreïn'
	},
	{
		type: 'Bangladesh',
		'ISO2': 'BD',
		'E164': 880,
		'prefix': '880',
		'fr': 'Bangladesh'
	},
	{
		type: 'Barbados',
		'ISO2': 'BB',
		'E164': 1,
		'prefix': '1-246',
		'fr': 'Barbade'
	},
	{
		type: 'Belarus',
		'ISO2': 'BY',
		'E164': 375,
		'prefix': '375',
		'fr': 'Biélorussie'
	},
	{
		type: 'Belgium',
		'ISO2': 'BE',
		'E164': 32,
		'prefix': '32',
		'fr': 'Belgique'
	},
	{
		type: 'Belize',
		'ISO2': 'BZ',
		'E164': 501,
		'prefix': '501',
		'fr': 'Belize'
	},
	{
		type: 'Benin',
		'ISO2': 'BJ',
		'E164': 229,
		'prefix': '229',
		'fr': 'Bénin'
	},
	{
		type: 'Bermuda',
		'ISO2': 'BM',
		'E164': 1,
		'prefix': '1-441',
		'fr': 'Bermudes'
	},
	{
		type: 'Bhutan',
		'ISO2': 'BT',
		'E164': 975,
		'prefix': '975',
		'fr': 'Bhoutan'
	},
	{
		type: 'Bolivia',
		'ISO2': 'BO',
		'E164': 591,
		'prefix': '591',
		'fr': 'Bolivie'
	},
	{
		type: 'Bosnia and Herzegovina',
		'ISO2': 'BA',
		'E164': 387,
		'prefix': '387',
		'fr': 'Bosnie-Herzégovine'
	},
	{
		type: 'Botswana',
		'ISO2': 'BW',
		'E164': 267,
		'prefix': '267',
		'fr': 'Botswana'
	},
	{
		type: 'Brazil',
		'ISO2': 'BR',
		'E164': 55,
		'prefix': '55',
		'fr': 'Brésil'
	},
	{
		type: 'British Indian Ocean Territory',
		'ISO2': 'IO',
		'E164': 246,
		'prefix': '246',
		'fr': 'Territoire britannique de l\'océan Indien'
	},
	{
		type: 'British Virgin Islands',
		'ISO2': 'VG',
		'E164': 1,
		'prefix': '1-284',
		'fr': 'Îles Vierges britanniques'
	},
	{
		type: 'Brunei',
		'ISO2': 'BN',
		'E164': 673,
		'prefix': '673',
		'fr': 'Brunei'
	},
	{
		type: 'Bulgaria',
		'ISO2': 'BG',
		'E164': 359,
		'prefix': '359',
		'fr': 'Bulgarie'
	},
	{
		type: 'Burkina Faso',
		'ISO2': 'BF',
		'E164': 226,
		'prefix': '226',
		'fr': 'Burkina Faso'
	},
	{
		type: 'Burundi',
		'ISO2': 'BI',
		'E164': 257,
		'prefix': '257',
		'fr': 'Burundi'
	},
	{
		type: 'Cambodia',
		'ISO2': 'KH',
		'E164': 855,
		'prefix': '855',
		'fr': 'Cambodge'
	},
	{
		type: 'Cameroon',
		'ISO2': 'CM',
		'E164': 237,
		'prefix': '237',
		'fr': 'Cameroun'
	},
	{
		type: 'Canada',
		'ISO2': 'CA',
		'E164': 1,
		'prefix': '1',
		'fr': 'Canada'
	},
	{
		type: 'Cape Verde',
		'ISO2': 'CV',
		'E164': 238,
		'prefix': '238',
		'fr': 'Cap-Vert'
	},
	{
		type: 'Cayman Islands',
		'ISO2': 'KY',
		'E164': 1,
		'prefix': '1-345',
		'fr': 'Îles Caïmans'
	},
	{
		type: 'Central African Republic',
		'ISO2': 'CF',
		'E164': 236,
		'prefix': '236',
		'fr': 'République centrafricaine'
	},
	{
		type: 'Chad',
		'ISO2': 'TD',
		'E164': 235,
		'prefix': '235',
		'fr': 'Tchad'
	},
	{
		type: 'Chile',
		'ISO2': 'CL',
		'E164': 56,
		'prefix': '56',
		'fr': 'Chili'
	},
	{
		type: 'China',
		'ISO2': 'CN',
		'E164': 86,
		'prefix': '86',
		'fr': 'Chine'
	},
	{
		type: 'Christmas Island',
		'ISO2': 'CX',
		'E164': 61,
		'prefix': '61',
		'fr': 'Île Christmas'
	},
	{
		type: 'Cocos Islands',
		'ISO2': 'CC',
		'E164': 61,
		'prefix': '61',
		'fr': 'Îles Cocos'
	},
	{
		type: 'Colombia',
		'ISO2': 'CO',
		'E164': 57,
		'prefix': '57',
		'fr': 'Colombie'
	},
	{
		type: 'Comoros',
		'ISO2': 'KM',
		'E164': 269,
		'prefix': '269',
		'fr': 'Comores'
	},
	{
		type: 'Cook Islands',
		'ISO2': 'CK',
		'E164': 682,
		'prefix': '682',
		'fr': 'Îles Cook'
	},
	{
		type: 'Costa Rica',
		'ISO2': 'CR',
		'E164': 506,
		'prefix': '506',
		'fr': 'Costa Rica'
	},
	{
		type: 'Croatia',
		'ISO2': 'HR',
		'E164': 385,
		'prefix': '385',
		'fr': 'Croatie'
	},
	{
		type: 'Cuba',
		'ISO2': 'CU',
		'E164': 53,
		'prefix': '53',
		'fr': 'Cuba'
	},
	{
		type: 'Curacao',
		'ISO2': 'CW',
		'E164': 599,
		'prefix': '599',
		'fr': 'Curaçao'
	},
	{
		type: 'Cyprus',
		'ISO2': 'CY',
		'E164': 357,
		'prefix': '357',
		'fr': 'Chypre'
	},
	{
		type: 'Czech Republic',
		'ISO2': 'CZ',
		'E164': 420,
		'prefix': '420',
		'fr': 'République tchèque'
	},
	{
		type: 'Democratic Republic of the Congo',
		'ISO2': 'CD',
		'E164': 243,
		'prefix': '243',
		'fr': 'République démocratique du Congo'
	},
	{
		type: 'Denmark',
		'ISO2': 'DK',
		'E164': 45,
		'prefix': '45',
		'fr': 'Danemark'
	},
	{
		type: 'Djibouti',
		'ISO2': 'DJ',
		'E164': 253,
		'prefix': '253',
		'fr': 'Djibouti'
	},
	{
		type: 'Dominica',
		'ISO2': 'DM',
		'E164': 1,
		'prefix': '1-767',
		'fr': 'Dominique'
	},
	{
		type: 'Dominican Republic',
		'ISO2': 'DO',
		'E164': 1,
		'prefix': '1-809, 1-829, 1-849',
		'fr': 'République dominicaine'
	},
	{
		type: 'East Timor',
		'ISO2': 'TL',
		'E164': 670,
		'prefix': '670',
		'fr': 'Timor oriental'
	},
	{
		type: 'Ecuador',
		'ISO2': 'EC',
		'E164': 593,
		'prefix': '593',
		'fr': 'Équateur'
	},
	{
		type: 'Egypt',
		'ISO2': 'EG',
		'E164': 20,
		'prefix': '20',
		'fr': 'Égypte'
	},
	{
		type: 'El Salvador',
		'ISO2': 'SV',
		'E164': 503,
		'prefix': '503',
		'fr': 'Salvador'
	},
	{
		type: 'Equatorial Guinea',
		'ISO2': 'GQ',
		'E164': 240,
		'prefix': '240',
		'fr': 'Guinée équatoriale'
	},
	{
		type: 'Eritrea',
		'ISO2': 'ER',
		'E164': 291,
		'prefix': '291',
		'fr': 'Érythrée'
	},
	{
		type: 'Estonia',
		'ISO2': 'EE',
		'E164': 372,
		'prefix': '372',
		'fr': 'Estonie'
	},
	{
		type: 'Ethiopia',
		'ISO2': 'ET',
		'E164': 251,
		'prefix': '251',
		'fr': 'Éthiopie'
	},
	{
		type: 'Falkland Islands',
		'ISO2': 'FK',
		'E164': 500,
		'prefix': '500',
		'fr': 'Îles Malouines'
	},
	{
		type: 'Faroe Islands',
		'ISO2': 'FO',
		'E164': 298,
		'prefix': '298',
		'fr': 'Îles Féroé'
	},
	{
		type: 'Fiji',
		'ISO2': 'FJ',
		'E164': 679,
		'prefix': '679',
		'fr': 'Fidji'
	},
	{
		type: 'Finland',
		'ISO2': 'FI',
		'E164': 358,
		'prefix': '358',
		'fr': 'Finlande'
	},
	{
		type: 'France',
		'ISO2': 'FR',
		'E164': 33,
		'prefix': '33',
		'fr': 'France'
	},
	{
		type: 'French Polynesia',
		'ISO2': 'PF',
		'E164': 689,
		'prefix': '689',
		'fr': 'Polynésie française'
	},
	{
		type: 'Gabon',
		'ISO2': 'GA',
		'E164': 241,
		'prefix': '241',
		'fr': 'Gabon'
	},
	{
		type: 'Gambia',
		'ISO2': 'GM',
		'E164': 220,
		'prefix': '220',
		'fr': 'Gambie'
	},
	{
		type: 'Georgia',
		'ISO2': 'GE',
		'E164': 995,
		'prefix': '995',
		'fr': 'Géorgie'
	},
	{
		type: 'Germany',
		'ISO2': 'DE',
		'E164': 49,
		'prefix': '49',
		'fr': 'Allemagne'
	},
	{
		type: 'Ghana',
		'ISO2': 'GH',
		'E164': 233,
		'prefix': '233',
		'fr': 'Ghana'
	},
	{
		type: 'Gibraltar',
		'ISO2': 'GI',
		'E164': 350,
		'prefix': '350',
		'fr': 'Gibraltar'
	},
	{
		type: 'Greece',
		'ISO2': 'GR',
		'E164': 30,
		'prefix': '30',
		'fr': 'Grèce'
	},
	{
		type: 'Greenland',
		'ISO2': 'GL',
		'E164': 299,
		'prefix': '299',
		'fr': 'Groenland'
	},
	{
		type: 'Grenada',
		'ISO2': 'GD',
		'E164': 1,
		'prefix': '1-473',
		'fr': 'Grenade'
	},
	{
		type: 'Guam',
		'ISO2': 'GU',
		'E164': 1,
		'prefix': '1-671',
		'fr': 'Guam'
	},
	{
		type: 'Guatemala',
		'ISO2': 'GT',
		'E164': 502,
		'prefix': '502',
		'fr': 'Guatemala'
	},
	{
		type: 'Guernsey',
		'ISO2': 'GG',
		'E164': 44,
		'prefix': '44-1481',
		'fr': 'Guernesey'
	},
	{
		type: 'Guinea',
		'ISO2': 'GN',
		'E164': 224,
		'prefix': '224',
		'fr': 'Guinée'
	},
	{
		type: 'Guinea-Bissau',
		'ISO2': 'GW',
		'E164': 245,
		'prefix': '245',
		'fr': 'Guinée-Bissau'
	},
	{
		type: 'Guyana',
		'ISO2': 'GY',
		'E164': 592,
		'prefix': '592',
		'fr': 'Guyana'
	},
	{
		type: 'Haiti',
		'ISO2': 'HT',
		'E164': 509,
		'prefix': '509',
		'fr': 'Haïti'
	},
	{
		type: 'Honduras',
		'ISO2': 'HN',
		'E164': 504,
		'prefix': '504',
		'fr': 'Honduras'
	},
	{
		type: 'Hong Kong',
		'ISO2': 'HK',
		'E164': 852,
		'prefix': '852',
		'fr': 'Hong Kong'
	},
	{
		type: 'Hungary',
		'ISO2': 'HU',
		'E164': 36,
		'prefix': '36',
		'fr': 'Hongrie'
	},
	{
		type: 'Iceland',
		'ISO2': 'IS',
		'E164': 354,
		'prefix': '354',
		'fr': 'Islande'
	},
	{
		type: 'India',
		'ISO2': 'IN',
		'E164': 91,
		'prefix': '91',
		'fr': 'Inde'
	},
	{
		type: 'Indonesia',
		'ISO2': 'ID',
		'E164': 62,
		'prefix': '62',
		'fr': 'Indonésie'
	},
	{
		type: 'Iran',
		'ISO2': 'IR',
		'E164': 98,
		'prefix': '98',
		'fr': 'Iran'
	},
	{
		type: 'Iraq',
		'ISO2': 'IQ',
		'E164': 964,
		'prefix': '964',
		'fr': 'Irak'
	},
	{
		type: 'Ireland',
		'ISO2': 'IE',
		'E164': 353,
		'prefix': '353',
		'fr': 'Irlande'
	},
	{
		type: 'Isle of Man',
		'ISO2': 'IM',
		'E164': 44,
		'prefix': '44-1624',
		'fr': 'Île de Man'
	},
	{
		type: 'Israel',
		'ISO2': 'IL',
		'E164': 972,
		'prefix': '972',
		'fr': 'Israël'
	},
	{
		type: 'Italy',
		'ISO2': 'IT',
		'E164': 39,
		'prefix': '39',
		'fr': 'Italie'
	},
	{
		type: 'Ivory Coast',
		'ISO2': 'CI',
		'E164': 225,
		'prefix': '225',
		'fr': 'Côte d\'Ivoire'
	},
	{
		type: 'Jamaica',
		'ISO2': 'JM',
		'E164': 1,
		'prefix': '1-876',
		'fr': 'Jamaïque'
	},
	{
		type: 'Japan',
		'ISO2': 'JP',
		'E164': 81,
		'prefix': '81',
		'fr': 'Japon'
	},
	{
		type: 'Jersey',
		'ISO2': 'JE',
		'E164': 44,
		'prefix': '44-1534',
		'fr': 'Jersey'
	},
	{
		type: 'Jordan',
		'ISO2': 'JO',
		'E164': 962,
		'prefix': '962',
		'fr': 'Jordanie'
	},
	{
		type: 'Kazakhstan',
		'ISO2': 'KZ',
		'E164': 7,
		'prefix': '7',
		'fr': 'Kazakhstan'
	},
	{
		type: 'Kenya',
		'ISO2': 'KE',
		'E164': 254,
		'prefix': '254',
		'fr': 'Kenya'
	},
	{
		type: 'Kiribati',
		'ISO2': 'KI',
		'E164': 686,
		'prefix': '686',
		'fr': 'Kiribati'
	},
	{
		type: 'Kosovo',
		'ISO2': 'XK',
		'E164': 383,
		'prefix': '383',
		'fr': 'Kosovo'
	},
	{
		type: 'Kuwait',
		'ISO2': 'KW',
		'E164': 965,
		'prefix': '965',
		'fr': 'Koweït'
	},
	{
		type: 'Kyrgyzstan',
		'ISO2': 'KG',
		'E164': 996,
		'prefix': '996',
		'fr': 'Kirghizistan'
	},
	{
		type: 'Laos',
		'ISO2': 'LA',
		'E164': 856,
		'prefix': '856',
		'fr': 'Laos'
	},
	{
		type: 'Latvia',
		'ISO2': 'LV',
		'E164': 371,
		'prefix': '371',
		'fr': 'Lettonie'
	},
	{
		type: 'Lebanon',
		'ISO2': 'LB',
		'E164': 961,
		'prefix': '961',
		'fr': 'Liban'
	},
	{
		type: 'Lesotho',
		'ISO2': 'LS',
		'E164': 266,
		'prefix': '266',
		'fr': 'Lesotho'
	},
	{
		type: 'Liberia',
		'ISO2': 'LR',
		'E164': 231,
		'prefix': '231',
		'fr': 'Libéria'
	},
	{
		type: 'Libya',
		'ISO2': 'LY',
		'E164': 218,
		'prefix': '218',
		'fr': 'Libye'
	},
	{
		type: 'Liechtenstein',
		'ISO2': 'LI',
		'E164': 423,
		'prefix': '423',
		'fr': 'Liechtenstein'
	},
	{
		type: 'Lithuania',
		'ISO2': 'LT',
		'E164': 370,
		'prefix': '370',
		'fr': 'Lituanie'
	},
	{
		type: 'Luxembourg',
		'ISO2': 'LU',
		'E164': 352,
		'prefix': '352',
		'fr': 'Luxembourg'
	},
	{
		type: 'Macau',
		'ISO2': 'MO',
		'E164': 853,
		'prefix': '853',
		'fr': 'Macao'
	},
	{
		type: 'Macedonia',
		'ISO2': 'MK',
		'E164': 389,
		'prefix': '389',
		'fr': 'Macédoine'
	},
	{
		type: 'Madagascar',
		'ISO2': 'MG',
		'E164': 261,
		'prefix': '261',
		'fr': 'Madagascar'
	},
	{
		type: 'Malawi',
		'ISO2': 'MW',
		'E164': 265,
		'prefix': '265',
		'fr': 'Malawi'
	},
	{
		type: 'Malaysia',
		'ISO2': 'MY',
		'E164': 60,
		'prefix': '60',
		'fr': 'Malaisie'
	},
	{
		type: 'Maldives',
		'ISO2': 'MV',
		'E164': 960,
		'prefix': '960',
		'fr': 'Maldives'
	},
	{
		type: 'Mali',
		'ISO2': 'ML',
		'E164': 223,
		'prefix': '223',
		'fr': 'Mali'
	},
	{
		type: 'Malta',
		'ISO2': 'MT',
		'E164': 356,
		'prefix': '356',
		'fr': 'Malte'
	},
	{
		type: 'Marshall Islands',
		'ISO2': 'MH',
		'E164': 692,
		'prefix': '692',
		'fr': 'Îles Marshall'
	},
	{
		type: 'Mauritania',
		'ISO2': 'MR',
		'E164': 222,
		'prefix': '222',
		'fr': 'Mauritanie'
	},
	{
		type: 'Mauritius',
		'ISO2': 'MU',
		'E164': 230,
		'prefix': '230',
		'fr': 'Maurice'
	},
	{
		type: 'Mayotte',
		'ISO2': 'YT',
		'E164': 262,
		'prefix': '262',
		'fr': 'Mayotte'
	},
	{
		type: 'Mexico',
		'ISO2': 'MX',
		'E164': 52,
		'prefix': '52',
		'fr': 'Mexique'
	},
	{
		type: 'Micronesia',
		'ISO2': 'FM',
		'E164': 691,
		'prefix': '691',
		'fr': 'Micronésie'
	},
	{
		type: 'Moldova',
		'ISO2': 'MD',
		'E164': 373,
		'prefix': '373',
		'fr': 'Moldavie'
	},
	{
		type: 'Monaco',
		'ISO2': 'MC',
		'E164': 377,
		'prefix': '377',
		'fr': 'Monaco'
	},
	{
		type: 'Mongolia',
		'ISO2': 'MN',
		'E164': 976,
		'prefix': '976',
		'fr': 'Mongolie'
	},
	{
		type: 'Montenegro',
		'ISO2': 'ME',
		'E164': 382,
		'prefix': '382',
		'fr': 'Monténégro'
	},
	{
		type: 'Montserrat',
		'ISO2': 'MS',
		'E164': 1,
		'prefix': '1-664',
		'fr': 'Montserrat'
	},
	{
		type: 'Morocco',
		'ISO2': 'MA',
		'E164': 212,
		'prefix': '212',
		'fr': 'Maroc'
	},
	{
		type: 'Mozambique',
		'ISO2': 'MZ',
		'E164': 258,
		'prefix': '258',
		'fr': 'Mozambique'
	},
	{
		type: 'Myanmar',
		'ISO2': 'MM',
		'E164': 95,
		'prefix': '95',
		'fr': 'Myanmar'
	},
	{
		type: 'Namibia',
		'ISO2': 'NA',
		'E164': 264,
		'prefix': '264',
		'fr': 'Namibie'
	},
	{
		type: 'Nauru',
		'ISO2': 'NR',
		'E164': 674,
		'prefix': '674',
		'fr': 'Nauru'
	},
	{
		type: 'Nepal',
		'ISO2': 'NP',
		'E164': 977,
		'prefix': '977',
		'fr': 'Népal'
	},
	{
		type: 'Netherlands',
		'ISO2': 'NL',
		'E164': 31,
		'prefix': '31',
		'fr': 'Pays-Bas'
	},
	{
		type: 'Netherlands Antilles',
		'ISO2': 'AN',
		'E164': 599,
		'prefix': '599',
		'fr': 'Antilles néerlandaises'
	},
	{
		type: 'New Caledonia',
		'ISO2': 'NC',
		'E164': 687,
		'prefix': '687',
		'fr': 'Nouvelle-Calédonie'
	},
	{
		type: 'New Zealand',
		'ISO2': 'NZ',
		'E164': 64,
		'prefix': '64',
		'fr': 'Nouvelle-Zélande'
	},
	{
		type: 'Nicaragua',
		'ISO2': 'NI',
		'E164': 505,
		'prefix': '505',
		'fr': 'Nicaragua'
	},
	{
		type: 'Niger',
		'ISO2': 'NE',
		'E164': 227,
		'prefix': '227',
		'fr': 'Niger'
	},
	{
		type: 'Nigeria',
		'ISO2': 'NG',
		'E164': 234,
		'prefix': '234',
		'fr': 'Nigéria'
	},
	{
		type: 'Niue',
		'ISO2': 'NU',
		'E164': 683,
		'prefix': '683',
		'fr': 'Niue'
	},
	{
		type: 'North Korea',
		'ISO2': 'KP',
		'E164': 850,
		'prefix': '850',
		'fr': 'Corée du Nord'
	},
	{
		type: 'Northern Mariana Islands',
		'ISO2': 'MP',
		'E164': 1,
		'prefix': '1-670',
		'fr': 'Îles Mariannes du Nord'
	},
	{
		type: 'Norway',
		'ISO2': 'NO',
		'E164': 47,
		'prefix': '47',
		'fr': 'Norvège'
	},
	{
		type: 'Oman',
		'ISO2': 'OM',
		'E164': 968,
		'prefix': '968',
		'fr': 'Oman'
	},
	{
		type: 'Pakistan',
		'ISO2': 'PK',
		'E164': 92,
		'prefix': '92',
		'fr': 'Pakistan'
	},
	{
		type: 'Palau',
		'ISO2': 'PW',
		'E164': 680,
		'prefix': '680',
		'fr': 'Palaos'
	},
	{
		type: 'Palestine',
		'ISO2': 'PS',
		'E164': 970,
		'prefix': '970',
		'fr': 'Palestine'
	},
	{
		type: 'Panama',
		'ISO2': 'PA',
		'E164': 507,
		'prefix': '507',
		'fr': 'Panama'
	},
	{
		type: 'Papua New Guinea',
		'ISO2': 'PG',
		'E164': 675,
		'prefix': '675',
		'fr': 'Papouasie-Nouvelle-Guinée'
	},
	{
		type: 'Paraguay',
		'ISO2': 'PY',
		'E164': 595,
		'prefix': '595',
		'fr': 'Paraguay'
	},
	{
		type: 'Peru',
		'ISO2': 'PE',
		'E164': 51,
		'prefix': '51',
		'fr': 'Pérou'
	},
	{
		type: 'Philippines',
		'ISO2': 'PH',
		'E164': 63,
		'prefix': '63',
		'fr': 'Philippines'
	},
	{
		type: 'Pitcairn',
		'ISO2': 'PN',
		'E164': 64,
		'prefix': '64',
		'fr': 'Îles Pitcairn'
	},
	{
		type: 'Poland',
		'ISO2': 'PL',
		'E164': 48,
		'prefix': '48',
		'fr': 'Pologne'
	},
	{
		type: 'Portugal',
		'ISO2': 'PT',
		'E164': 351,
		'prefix': '351',
		'fr': 'Portugal'
	},
	{
		type: 'Puerto Rico',
		'ISO2': 'PR',
		'E164': 1,
		'prefix': '1-787, 1-939',
		'fr': 'Porto Rico'
	},
	{
		type: 'Qatar',
		'ISO2': 'QA',
		'E164': 974,
		'prefix': '974',
		'fr': 'Qatar'
	},
	{
		type: 'Republic of the Congo',
		'ISO2': 'CG',
		'E164': 242,
		'prefix': '242',
		'fr': 'République du Congo'
	},
	{
		type: 'Reunion',
		'ISO2': 'RE',
		'E164': 262,
		'prefix': '262',
		'fr': 'La Réunion'
	},
	{
		type: 'Romania',
		'ISO2': 'RO',
		'E164': 40,
		'prefix': '40',
		'fr': 'Roumanie'
	},
	{
		type: 'Russia',
		'ISO2': 'RU',
		'E164': 7,
		'prefix': '7',
		'fr': 'Russie'
	},
	{
		type: 'Rwanda',
		'ISO2': 'RW',
		'E164': 250,
		'prefix': '250',
		'fr': 'Rwanda'
	},
	{
		type: 'Saint Barthelemy',
		'ISO2': 'BL',
		'E164': 590,
		'prefix': '590',
		'fr': 'Saint-Barthélemy'
	},
	{
		type: 'Saint Helena',
		'ISO2': 'SH',
		'E164': 290,
		'prefix': '290',
		'fr': 'Sainte-Hélène'
	},
	{
		type: 'Saint Kitts and Nevis',
		'ISO2': 'KN',
		'E164': 1,
		'prefix': '1-869',
		'fr': 'Saint-Christophe-et-Niévès'
	},
	{
		type: 'Saint Lucia',
		'ISO2': 'LC',
		'E164': 1,
		'prefix': '1-758',
		'fr': 'Sainte-Lucie'
	},
	{
		type: 'Saint Martin',
		'ISO2': 'MF',
		'E164': 1,
		'prefix': '590',
		'fr': 'Saint-Martin'
	},
	{
		type: 'Saint Pierre and Miquelon',
		'ISO2': 'PM',
		'E164': 508,
		'prefix': '508',
		'fr': 'Saint-Pierre-et-Miquelon'
	},
	{
		type: 'Saint Vincent and the Grenadines',
		'ISO2': 'VC',
		'E164': 1,
		'prefix': '1-784',
		'fr': 'Saint-Vincent-et-les-Grenadines'
	},
	{
		type: 'Samoa',
		'ISO2': 'WS',
		'E164': 685,
		'prefix': '685',
		'fr': 'Samoa'
	},
	{
		type: 'San Marino',
		'ISO2': 'SM',
		'E164': 378,
		'prefix': '378',
		'fr': 'Saint-Marin'
	},
	{
		type: 'Sao Tome and Principe',
		'ISO2': 'ST',
		'E164': 239,
		'prefix': '239',
		'fr': 'Sao Tomé-et-Principe'
	},
	{
		type: 'Saudi Arabia',
		'ISO2': 'SA',
		'E164': 966,
		'prefix': '966',
		'fr': 'Arabie saoudite'
	},
	{
		type: 'Senegal',
		'ISO2': 'SN',
		'E164': 221,
		'prefix': '221',
		'fr': 'Sénégal'
	},
	{
		type: 'Serbia',
		'ISO2': 'RS',
		'E164': 381,
		'prefix': '381',
		'fr': 'Serbie'
	},
	{
		type: 'Seychelles',
		'ISO2': 'SC',
		'E164': 248,
		'prefix': '248',
		'fr': 'Seychelles'
	},
	{
		type: 'Sierra Leone',
		'ISO2': 'SL',
		'E164': 232,
		'prefix': '232',
		'fr': 'Sierra Leone'
	},
	{
		type: 'Singapore',
		'ISO2': 'SG',
		'E164': 65,
		'prefix': '65',
		'fr': 'Singapour'
	},
	{
		type: 'Sint Maarten',
		'ISO2': 'SX',
		'E164': 1,
		'prefix': '1-721',
		'fr': 'Saint-Martin'
	},
	{
		type: 'Slovakia',
		'ISO2': 'SK',
		'E164': 421,
		'prefix': '421',
		'fr': 'Slovaquie'
	},
	{
		type: 'Slovenia',
		'ISO2': 'SI',
		'E164': 386,
		'prefix': '386',
		'fr': 'Slovénie'
	},
	{
		type: 'Solomon Islands',
		'ISO2': 'SB',
		'E164': 677,
		'prefix': '677',
		'fr': 'Îles Salomon'
	},
	{
		type: 'Somalia',
		'ISO2': 'SO',
		'E164': 252,
		'prefix': '252',
		'fr': 'Somalie'
	},
	{
		type: 'South Africa',
		'ISO2': 'ZA',
		'E164': 27,
		'prefix': '27',
		'fr': 'Afrique du Sud'
	},
	{
		type: 'South Korea',
		'ISO2': 'KR',
		'E164': 82,
		'prefix': '82',
		'fr': 'Corée du Sud'
	},
	{
		type: 'South Sudan',
		'ISO2': 'SS',
		'E164': 211,
		'prefix': '211',
		'fr': 'Soudan du Sud'
	},
	{
		type: 'Spain',
		'ISO2': 'ES',
		'E164': 34,
		'prefix': '34',
		'fr': 'Espagne'
	},
	{
		type: 'Sri Lanka',
		'ISO2': 'LK',
		'E164': 94,
		'prefix': '94',
		'fr': 'Sri Lanka'
	},
	{
		type: 'Sudan',
		'ISO2': 'SD',
		'E164': 249,
		'prefix': '249',
		'fr': 'Soudan'
	},
	{
		type: 'Suriname',
		'ISO2': 'SR',
		'E164': 597,
		'prefix': '597',
		'fr': 'Suriname'
	},
	{
		type: 'Svalbard and Jan Mayen',
		'ISO2': 'SJ',
		'E164': 47,
		'prefix': '47',
		'fr': 'Svalbard et Jan Mayen'
	},
	{
		type: 'Swaziland',
		'ISO2': 'SZ',
		'E164': 268,
		'prefix': '268',
		'fr': 'Eswatini'
	},
	{
		type: 'Sweden',
		'ISO2': 'SE',
		'E164': 46,
		'prefix': '46',
		'fr': 'Suède'
	},
	{
		type: 'Switzerland',
		'ISO2': 'CH',
		'E164': 41,
		'prefix': '41',
		'fr': 'Suisse'
	},
	{
		type: 'Syria',
		'ISO2': 'SY',
		'E164': 963,
		'prefix': '963',
		'fr': 'Syrie'
	},
	{
		type: 'Taiwan',
		'ISO2': 'TW',
		'E164': 886,
		'prefix': '886',
		'fr': 'Taïwan'
	},
	{
		type: 'Tajikistan',
		'ISO2': 'TJ',
		'E164': 992,
		'prefix': '992',
		'fr': 'Tadjikistan'
	},
	{
		type: 'Tanzania',
		'ISO2': 'TZ',
		'E164': 255,
		'prefix': '255',
		'fr': 'Tanzanie'
	},
	{
		type: 'Thailand',
		'ISO2': 'TH',
		'E164': 66,
		'prefix': '66',
		'fr': 'Thaïlande'
	},
	{
		type: 'Togo',
		'ISO2': 'TG',
		'E164': 228,
		'prefix': '228',
		'fr': 'Togo'
	},
	{
		type: 'Tokelau',
		'ISO2': 'TK',
		'E164': 690,
		'prefix': '690',
		'fr': 'Tokelau'
	},
	{
		type: 'Tonga',
		'ISO2': 'TO',
		'E164': 676,
		'prefix': '676',
		'fr': 'Tonga'
	},
	{
		type: 'Trinidad and Tobago',
		'ISO2': 'TT',
		'E164': 1,
		'prefix': '1-868',
		'fr': 'Trinité-et-Tobago'
	},
	{
		type: 'Tunisia',
		'ISO2': 'TN',
		'E164': 216,
		'prefix': '216',
		'fr': 'Tunisie'
	},
	{
		type: 'Turkey',
		'ISO2': 'TR',
		'E164': 90,
		'prefix': '90',
		'fr': 'Turquie'
	},
	{
		type: 'Turkmenistan',
		'ISO2': 'TM',
		'E164': 993,
		'prefix': '993',
		'fr': 'Turkménistan'
	},
	{
		type: 'Turks and Caicos Islands',
		'ISO2': 'TC',
		'E164': 1,
		'prefix': '1-649',
		'fr': 'Îles Turques-et-Caïques'
	},
	{
		type: 'Tuvalu',
		'ISO2': 'TV',
		'E164': 688,
		'prefix': '688',
		'fr': 'Tuvalu'
	},
	{
		type: 'U.S. Virgin Islands',
		'ISO2': 'VI',
		'E164': 1,
		'prefix': '1-340',
		'fr': 'Îles Vierges des États-Unis'
	},
	{
		type: 'Uganda',
		'ISO2': 'UG',
		'E164': 256,
		'prefix': '256',
		'fr': 'Ouganda'
	},
	{
		type: 'Ukraine',
		'ISO2': 'UA',
		'E164': 380,
		'prefix': '380',
		'fr': 'Ukraine'
	},
	{
		type: 'United Arab Emirates',
		'ISO2': 'AE',
		'E164': 971,
		'prefix': '971',
		'fr': 'Émirats arabes unis'
	},
	{
		type: 'United Kingdom',
		'ISO2': 'GB',
		'E164': 44,
		'prefix': '44',
		'fr': 'Royaume-Uni'
	},
	{
		type: 'United States',
		'ISO2': 'US',
		'E164': 1,
		'prefix': '1',
		'fr': 'États-Unis'
	},
	{
		type: 'Uruguay',
		'ISO2': 'UY',
		'E164': 598,
		'prefix': '598',
		'fr': 'Uruguay'
	},
	{
		type: 'Uzbekistan',
		'ISO2': 'UZ',
		'E164': 998,
		'prefix': '998',
		'fr': 'Ouzbékistan'
	},
	{
		type: 'Vanuatu',
		'ISO2': 'VU',
		'E164': 678,
		'prefix': '678',
		'fr': 'Vanuatu'
	},
	{
		type: 'Vatican',
		'ISO2': 'VA',
		'E164': 39,
		'prefix': '379',
		'fr': 'Vatican'
	},
	{
		type: 'Venezuela',
		'ISO2': 'VE',
		'E164': 58,
		'prefix': '58',
		'fr': 'Venezuela'
	},
	{
		type: 'Vietnam',
		'ISO2': 'VN',
		'E164': 84,
		'prefix': '84',
		'fr': 'Viêt Nam'
	},
	{
		type: 'Wallis and Futuna',
		'ISO2': 'WF',
		'E164': 681,
		'prefix': '681',
		'fr': 'Wallis-et-Futuna'
	},
	{
		type: 'Western Sahara',
		'ISO2': 'EH',
		'E164': 212,
		'prefix': '212',
		'fr': 'Sahara occidental'
	},
	{
		type: 'Yemen',
		'ISO2': 'YE',
		'E164': 967,
		'prefix': '967',
		'fr': 'Yémen'
	},
	{
		type: 'Zambia',
		'ISO2': 'ZM',
		'E164': 260,
		'prefix': '260',
		'fr': 'Zambie'
	},
	{
		type: 'Zimbabwe',
		'ISO2': 'ZW',
		'E164': 263,
		'prefix': '263',
		'fr': 'Zimbabwe'
	}
]

export default Country



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/Country.js